<!-- PAGE TITLE
        ================================================== -->
<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="position-relative">
                        <h1>Blogs</h1>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>

<section class="overflow-visible bg-light-yellow2">
    <div class="container">

        <div class="row g-xl-5 mt-n2-9">

            <div class="col-md-4 col-lg-4 mt-2-9 wow fadeInUp" *ngFor="let blog of blogs">

                <article class="card card-style-10 bg-transparent">

                    <div class="image-box">

                        <div class="image">

                            <img [src]="blog.BannerImage
          ? imageBaseUrl + blog.BannerImage
          : '/assets/images/blog/no-image.jpg'" (error)="setDefaultImage($event)">

                        </div>

                    </div>

                    <div class="card-body border-radius-10">

                        <ul class="list-unstyled mb-3">

                            <li class="d-inline-block me-3 text-capitalize">

                                <i class="fa fa-calendar me-2 text-primary"></i>

                                {{ blog.EventDate | date:'dd MMM, yyyy' }}

                            </li>

                        </ul>

                        <h3 class="mb-2 h4">

                            <a class="cursor-auto h-4">

                                {{ blog.Title }}

                            </a>

                        </h3>

                        <a [routerLink]="['/blog-details', generateSlug(blog.Title)]">
                            Read more
                            <i class="fas fa-arrow-right align-middle ms-1 text-primary"></i>
                        </a>

                    </div>

                </article>

            </div>

        </div>

    </div>
</section>